import { grey } from '@material-ui/core/colors';
import {drawerWidth } from '../../variables/config'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer +1,
    boxShadow:'none',
    borderBottom:`1px solid ${grey[300]}`,
    background: 'white',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    zIndex: theme.zIndex.drawer +1,
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    boxShadow:'none',
    borderBottom:`1px solid ${grey[300]}`,
    background: 'white',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menu:{
    color:theme.palette.secondary.main
  },
  title:{
    marginTop: '9px',
    color:theme.palette.secondary.main
  },
  bor:{
    border: '1px solid red'
  }


  
});

export default styles;
